import { useEffect, useState } from 'react';
import styles from './ResetPassword.module.css';
import toneLogo from '../../assests/images/tone-logo.png';
import { useDispatch } from 'react-redux';
import { AppDispatch } from '../../store';
import { ResetPasswordInputs } from '../../dtos/auth';
import { EyeSlashIcon, EyeIcon, LockClosedIcon } from '@heroicons/react/24/outline';
import { useSearchParams } from 'react-router-dom';
import { resetPasswordTrigger } from '../../slices/authSlice';
import { useNavigate } from 'react-router-dom';
import image4 from '../../assests/images/Image 4.png';
import image5 from '../../assests/images/Image 5.png';
import Form from '../Layout/Form';

const ResetPassword = () => {
  useEffect(() => {
    console.log('Reset password token', token);
  });

  const [showPassword, setShowPassword] = useState(false);
  const [showConfirmPassword, setShowConfirmPassword] = useState(false);
  const dispatch = useDispatch<AppDispatch>();
  const [searchParams] = useSearchParams();
  const token = searchParams.get('token');
  const navigate = useNavigate();

  const [formData, setFormData] = useState<ResetPasswordInputs>({
    password: '',
    confirmPassword: ''
  });
  const [formErrors, setFormErrors] = useState<Record<string, string>>({});
  const [isSubmitting, setIsSubmitting] = useState(false);

  const handleFormFieldChange = (fieldName: string, value: any) => {
    setFormData(prev => ({
      ...prev,
      [fieldName]: value
    }));
    
    // Clear validation error for this field
    if (formErrors[fieldName]) {
      setFormErrors(prev => {
        const { [fieldName]: removed, ...rest } = prev;
        return rest;
      });
    }
  };

  const togglePasswordVisibility = () => {
    setShowPassword((prevState: boolean) => !prevState);
  };
  const toggleConfirmPasswordVisibility = () => {
    setShowConfirmPassword((prevState: boolean) => !prevState);
  };

  const onSubmit = async (data: Record<string, any>) => {
    // Validate form data
    const errors: Record<string, string> = {};
    if (!data.password || data.password.trim() === '') {
      errors.password = 'Password is required';
    } else if (data.password.length < 6) {
      errors.password = 'Password must be at least 6 characters long';
    }
    if (!data.confirmPassword || data.confirmPassword.trim() === '') {
      errors.confirmPassword = 'Please confirm your password';
    } else if (data.confirmPassword !== data.password) {
      errors.confirmPassword = 'Passwords do not match';
    }

    if (Object.keys(errors).length > 0) {
      setFormErrors(errors);
      return;
    }

    setIsSubmitting(true);
    const toastId = console.log('Processing...');
    
    try {
      if (token) {
        const response = await dispatch(
          resetPasswordTrigger({ resetToken: token, newPassword: data.password })
        ).unwrap();
        
        console.log('Success:', response.message);
      }
      navigate('/');
    } catch (error) {
      console.log('An error occurred while resetting your password');
    } finally {
      setIsSubmitting(false);
    }
  };

  // Form schema
  const formSchema = [
    {
      name: 'password',
      type: 'password' as const,
      label: 'Password',
      required: true,
      placeholder: 'Enter your password',
      minLength: 6
    },
    {
      name: 'confirmPassword',
      type: 'password' as const,
      label: 'Confirm Password',
      required: true,
      placeholder: 'Re-enter your password'
    }
  ];
  return (
    <div className={styles.page}>
      <div className={styles.backgroundLeft}>
        <img src={image4} alt="image54" />
      </div>
      <div className={styles.backgroundRight}>
        <img src={image5} alt="image5" />
      </div>
      <div className={styles.container}>
        <img src={toneLogo} alt="Logo" className={styles.logo} />
        <div className={styles.formContainer}>
          <h3 className={styles.title}>Reset Password </h3>
          
          <Form
            schema={formSchema}
            initialData={formData}
            onSubmit={onSubmit}
            onFieldChange={handleFormFieldChange}
            validationErrors={formErrors}
            isLoading={isSubmitting}
            submitButtonText="Reset Password"
            submitButtonProps={{
              className: styles.submitButton
            }}
            className={styles.form}
          />
        </div>
      </div>
    </div>
  );
};

export default ResetPassword;
